"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalSearchRequestBodySchema = void 0;
var zod_1 = require("zod");
exports.LocalSearchRequestBodySchema = zod_1.z.object({
    // "MOTEL" | "AROUND" | "HOTEL" | "GUESTHOUSE" | "PENSION" | "KEYWORD" | "AREA"
    pageName: zod_1.z.string(),
    checkInDate: zod_1.z.string().nullish(),
    checkOutDate: zod_1.z.string().nullish(),
    capacityAdults: zod_1.z.number().nullish(),
    childrenAges: zod_1.z.array(zod_1.z.number()).nullish(),
    /** 위도 */
    latitude: zod_1.z.number().nullish(),
    /** 경도 */
    longitude: zod_1.z.number().nullish(),
    /** 위경도 측위 방식 (DEFAULT, GPS, MANUAL) */
    locationType: zod_1.z.string().nullish(),
    /** 위경도 측위 시간 (Unix Timestamp 형식) */
    locationTime: zod_1.z.number().nullish(),
    /** 정렬 순서 */
    sort: zod_1.z.string().nullish(),
    page: zod_1.z.number().nullish(),
    searchType: zod_1.z.string().nullish(),
    region: zod_1.z.number().nullish(),
    filters: zod_1.z.array(zod_1.z.record(zod_1.z.string(), zod_1.z.any())).nullish(),
    keyword: zod_1.z.string().nullish(), // pageName=KEYWORD (SRP)일 때 필수
});
